<div>

  <!-- Regions -->
  <div class="section-regions" *ngIf="!isHideRegionSelection && !loading && regions.length > 0">
    <div class="container">
      <div class="row">
        <div class="col text-center">
          <span class="region-label">I'm based in </span>
          <select class="form-select form-select-lg border-2 region-select" [(ngModel)]="regionSlug" (change)="selectRegion()">
            <option *ngFor="let region of regions" [value]="region.slug">{{ region.name }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <br/>

  <!-- Pricing Boxes-->
  <div class="section-pricing-boxes" *ngIf="!loading && products.length > 0">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-6 col-md-4 col-lg-4" *ngFor="let product of products; index as i; trackBy:identity">
          <div class="tier">
            <div class="pricing-box">
              <div class="pricing-padding">
                <div class="text-center">
                  <br/>
                  <div class="name">
                  <span [ngSwitch]="product.membershipProperties!.code">
                    <span *ngSwitchCase="'apple'">Explorer</span>
                    <span *ngSwitchCase="'hobbyist'">Creator</span>
                    <span *ngSwitchCase="'monthly'">Luminary</span>

                    <span *ngSwitchCase="'raspberry'">Explorer</span>
                    <span *ngSwitchCase="'strawberry'">Creator</span>
                    <span *ngSwitchCase="'blueberry'">Luminary</span>
                  </span>
                  </div>
                  <div class="dollar">
                    <span class=""><span class="mo">{{ product.currency! | currencySymbol }}</span>{{ product.amount! / 100 }}</span><span class="mo">/mo</span>
                  </div>
                  <br/>
                </div>
                <ul class="list-unstyled">
                  <li>
                    <span [ngSwitch]="product.membershipProperties!.code">
                      <span *ngSwitchCase="'apple'"><strong>10 hours</strong> per month</span>
                      <span *ngSwitchCase="'hobbyist'"><strong>40 hours</strong> per month</span>
                      <span *ngSwitchCase="'monthly'"><strong>Unlimited hours</strong> per month</span>

                      <span *ngSwitchCase="'raspberry'"><strong>10 hours</strong> per month</span>
                      <span *ngSwitchCase="'strawberry'"><strong>40 hours</strong> per month</span>
                      <span *ngSwitchCase="'blueberry'"><strong>120 hours</strong> per month</span>
                    </span>
                  </li>
                  <li>
                    <span [ngSwitch]="product.membershipProperties!.code">
                      <span *ngSwitchCase="'apple'">Bring a guest for <strong>{{ product.membershipProperties!.overageAmount! / 100 | money: (product.currency!):2:true }}/hr</strong></span>
                      <span *ngSwitchCase="'hobbyist'"><strong>5 free</strong> guest hours</span>
                      <span *ngSwitchCase="'monthly'"><strong>20 free</strong> guest hours</span>

                      <span *ngSwitchCase="'raspberry'">Bring a guest for <strong>{{ product.membershipProperties!.overageAmount! / 100 | money: (product.currency!):2:true }}/hr</strong></span>
                      <span *ngSwitchCase="'strawberry'"><strong>5 free</strong> guest hours</span>
                      <span *ngSwitchCase="'blueberry'"><strong>20 free</strong> guest hours</span>
                    </span>
                  </li>
                  <li>Roll over unused hours <span class="badge">New</span></li>
                </ul>
                <div class="text-center" style="padding: 12px 0;">
                  <br/>
                  <a role="button" (click)="selectProduct(product)" class="btn btn-primary btn-next circular">
                    {{ promotionCode === 'TRIAL7' ? 'Start Free Trial' : 'Get Started' }}
                  </a>
                  <br/>
                  <br/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
